function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 210,
  height: 2,
  y: 90,
  fill: "#006FFF",
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(114 47)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 86,
  height: 43,
  fill: "#006EFF",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0086FF",
  d: "M62,0 L76.2602496,0 L76.2602496,16.3346066 C76.2602496,17.4391761 75.3648191,18.3346066 74.2602496,18.3346066 L64,18.3346066 C62.8954305,18.3346066 62,17.4391761 62,16.3346066 L62,0 L62,0 Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 53,
  height: 43,
  fill: "#0086FF",
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 97,
  height: 90,
  fill: "#006EFF",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0086FF",
  d: "M53,0 L74,0 L74,16.3346066 C74,17.4391761 73.1045695,18.3346066 72,18.3346066 L55,18.3346066 C53.8954305,18.3346066 53,17.4391761 53,16.3346066 L53,0 L53,0 Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 90,
  fill: "#0086FF",
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(61 37)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 89.381,
  height: 55.201,
  x: 0.063,
  fill: "#82DDFF",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6F4FF",
  d: "M67.9010695,0 L80.7352941,0 L80.7352941,14.5602898 C80.7352941,15.6648593 79.8398636,16.5602898 78.7352941,16.5602898 L69.9010695,16.5602898 C68.7965,16.5602898 67.9010695,15.6648593 67.9010695,14.5602898 L67.9010695,0 L67.9010695,0 Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 59.587,
  height: 55.201,
  x: 0.063,
  fill: "#D6F4FF",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.502,
  height: 16.56,
  fill: "#82DDFF",
  opacity: 0.3,
  rx: 2,
  transform: "translate(16.564 14.72)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20.168,
  height: 3,
  x: 20.231,
  y: 43.001,
  fill: "#82DDFF",
  rx: 1.5
})));

function SvgPackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 93,
    viewBox: "0 0 210 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.3cb5b137.svg";
export { ForwardRef as ReactComponent };